module.exports = __webpack_public_path__ + "media/masterplan-north.b37d92f0.svg";